function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpinner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "200px",
    height: "200px",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    style: {
      marginRight: "-2px",
      display: "block",
      backgroundRepeatY: "initial",
      backgroundRepeatX: "initial",
      backgroundColor: "rgb(255, 255, 255)",
      animationPlayState: "paused"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 17.5,
    y: 27.200679779052734,
    width: 15,
    height: 45.59864044189453,
    fill: "#103755",
    style: {
      animationPlayState: "paused"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.5,
    y: 26.016368865966797,
    width: 15,
    height: 47.967262268066406,
    fill: "#eeb808",
    style: {
      animationPlayState: "paused"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 67.5,
    y: 21,
    width: 15,
    height: 58,
    fill: "#707b8e",
    style: {
      animationPlayState: "paused"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinner);
export default __webpack_public_path__ + "static/media/spinner.2498f9d3fee61f4ded35bedf651dc405.svg";
export { ForwardRef as ReactComponent };